export const getMediaFullUrl = (path: string) =>
  `${process.env.GATSBY_STRAPI_API_URL?.includes('127') ? process.env.GATSBY_STRAPI_API_URL : ''}${path}`;
